import { getBuyerId } from 'dibs-cookie-jar';

import { sendAnalyticsData } from './perfAnalyticsHelpers.ts';
import { getForwardedHost } from './helpers.ts';

export const trackClientError = ({
    rumTransactionName,
    monitoringGroupName,
    errorMessage,
    errorName,
    errorStack,
}: {
    rumTransactionName: string;
    monitoringGroupName: string;
    errorMessage: string;
    errorName: string;
    errorStack: string;
}): void => {
    const payload = {
        rumTransactionName,
        monitoringGroupName,
        forwardedHost: getForwardedHost(),
        clientUrl: location.href,
        clientUserId: getBuyerId(document.cookie) || undefined,
        errorMessage,
        errorName,
        errorStack,
    };

    sendAnalyticsData(
        `${location.protocol}//${location.host}/soa/client-analytics/error/`,
        payload
    );
};
